import React from 'react';
import classnames from 'classnames';

import BaseTrigger from './BaseTrigger';
import useResponsiveValue from '../responsive-values/useResponsivevalue';

export type TriggerMode = 'click' | 'hover' | 'none';

interface Props {
	children: React.ReactNode;
	backdrop?: 'visible' | 'none';
	trigger?: any;
	componentId?: string;
}

const OverlayTrigger = (props: Props) => {
	const trigger = useResponsiveValue(props?.trigger ?? 'click');
	const role = trigger === 'click' ? 'button' : undefined;
	const containerClasses = classnames('outline-0 bg-transparent bn pa0 dib bg-red', {
		pointer: trigger === 'click',
	});

	return (
		<BaseTrigger
			componentId={props.componentId}
			role={role}
			tabIndex={0}
			style={{ zIndex: 2000 }}
			trigger={trigger}
			className={containerClasses}
		>
			{props.children}
		</BaseTrigger>
	);
};

export default OverlayTrigger;
